import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { getFormDataWithParams, getPLSkey, getSKey, } from '../../base/utils';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { CHECK_IF_CAN_SHARE_TO_QQ, CHECK_SKEY_AUTH, GET_DISCUSS_GROUP_MEMBER, GET_FRIEND_INFO, GET_GROUP_INFO, GET_GROUP_MEMBER, GET_QQ_FRIENDS, SET_TIPS_AFTER_IMPORT, SHARE_QQ_TIM, } from './cgi-path';
import { IUserInfoDomainService } from '../../user-info/service/user-info-domain-service.interface';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
var QQ_SHARE_TIPS_SHOWED_FLAG = 1;
var QQShareRepository = /** @class */ (function () {
    function QQShareRepository(docMetaDomainService, networkRequestService, userInfoDomainService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
        this.userInfoDomainService = userInfoDomainService;
    }
    QQShareRepository.prototype.checkIfCanShare = function () {
        return __awaiter(this, arguments, void 0, function (shouldAddUFlag) {
            var params, config, urlParams, url;
            if (shouldAddUFlag === void 0) { shouldAddUFlag = false; }
            return __generator(this, function (_a) {
                params = getFormDataWithParams({
                    padId: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                });
                config = {
                    contentType: 'application/x-www-form-urlencoded',
                };
                urlParams = __assign({}, (shouldAddUFlag ? { uflag: 'qqsig' } : null));
                url = addURLParameters(CHECK_IF_CAN_SHARE_TO_QQ, urlParams);
                return [2 /*return*/, this.networkRequestService.instance.post(url, params, config)];
            });
        });
    };
    QQShareRepository.prototype.setTipsAfterImport = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var fileMd5, guestUid, guestUidType, params;
            return __generator(this, function (_a) {
                fileMd5 = options.fileMd5, guestUid = options.guestUid, guestUidType = options.guestUidType;
                params = {
                    file_md5: fileMd5,
                    guest_uid: guestUid,
                    guest_uid_type: guestUidType,
                    tips_showed_fl: QQ_SHARE_TIPS_SHOWED_FLAG,
                };
                return [2 /*return*/, this.networkRequestService.instance.post(SET_TIPS_AFTER_IMPORT, __assign({}, params))];
            });
        });
    };
    QQShareRepository.prototype.shareToQQOrTIM = function (uinList_1) {
        return __awaiter(this, arguments, void 0, function (uinList, shouldAddUFlag) {
            var params, config, urlParams, url;
            if (shouldAddUFlag === void 0) { shouldAddUFlag = false; }
            return __generator(this, function (_a) {
                params = getFormDataWithParams({
                    padid: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                    domainid: this.docMetaDomainService.docMetaEntity.padInfo.domainId,
                    uins: JSON.stringify(uinList),
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                });
                config = {
                    contentType: 'application/x-www-form-urlencoded',
                };
                urlParams = __assign({}, (shouldAddUFlag ? { uflag: 'qqsig' } : null));
                url = addURLParameters(SHARE_QQ_TIM, urlParams);
                return [2 /*return*/, this.networkRequestService.instance.post(url, params, config)];
            });
        });
    };
    /**
     * 请求好友关系链
     */
    QQShareRepository.prototype.fetchFriendsInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var paramObj, url;
            return __generator(this, function (_a) {
                paramObj = {
                    t: (new Date()).getTime(),
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                url = addURLParameters(GET_QQ_FRIENDS, paramObj);
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    /**
     * 请求群或者讨论组信息
     */
    QQShareRepository.prototype.fetchGroupMember = function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            var paramObj, url;
            return __generator(this, function (_a) {
                paramObj = {
                    dstuin: groupId,
                    t: (new Date()).getTime(),
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                url = addURLParameters(GET_GROUP_MEMBER, paramObj);
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    QQShareRepository.prototype.fetchDiscussGroupMember = function (discussGroupId) {
        return __awaiter(this, void 0, void 0, function () {
            var paramObj, url;
            return __generator(this, function (_a) {
                paramObj = {
                    dstuin: discussGroupId,
                    t: (new Date()).getTime(),
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                url = addURLParameters(GET_DISCUSS_GROUP_MEMBER, paramObj);
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    /**
     * 校验 QQ p_lskey, p_skey 有效性
     */
    QQShareRepository.prototype.checkSkeyAuth = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    uin: this.userInfoDomainService.userInfoAggregate.userInfo.uin,
                    p_lskey: getPLSkey() || '',
                    p_skey: getSKey() || '',
                };
                return [2 /*return*/, this.networkRequestService.instance.post(CHECK_SKEY_AUTH, __assign({}, params))];
            });
        });
    };
    /**
     * 请求群信息
     */
    QQShareRepository.prototype.fetchGroupInfo = function (groupId) {
        var params = {
            groupCode: groupId,
            xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
        };
        return this.networkRequestService.instance.post(GET_GROUP_INFO, __assign({}, params));
    };
    /**
     * 请求好友信息
     */
    QQShareRepository.prototype.fetchFriendInfo = function (uin) {
        var params = {
            uin: "".concat(uin),
            xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
        };
        return this.networkRequestService.instance.post(GET_FRIEND_INFO, __assign({}, params));
    };
    QQShareRepository = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __param(2, IUserInfoDomainService),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], QQShareRepository);
    return QQShareRepository;
}());
export default QQShareRepository;
